import { Component, Inject, OnInit } from '@angular/core';
import {  MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AbstractControl, UntypedFormControl, Validators } from '@angular/forms';
import { AssignUserService } from '../assign-user.service';
import { AddNewUserModalComponent } from 'projects/app-home/src/app/add-new-user-modal/add-new-user-modal.component';
// import { MyErrorStateMatcher } from 'src/app/common-module/user-profile/user-profile.component';

import {ErrorStateMatcher} from '@angular/material/core';
@Component({
  selector: 'app-assign-user-popup',
  templateUrl: './assign-user-popup.component.html',
  styleUrls: ['./assign-user-popup.component.css']
})
export class AssignUserPopupComponent implements OnInit {


  territoryForm: UntypedFormControl = new UntypedFormControl('', [Validators.required, SymbolsAndSapceValidation]);
  matcher = new ErrorStateMatcher();
  userLoader = false;

  SubUserList
  showErrorMessage1: any = false;
  showErrorMessage2: any = false;
  SelectedSubUser:any;
  mapid 
  territoryList;
  SelectedTrrData;
  SubUserLayer:any
  Module: any;


  constructor(
    public dialogRef: MatDialogRef<AssignUserPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public matdata: any,
    private assignUserService: AssignUserService,
    private matDialog:MatDialog) {

    this.mapid = matdata.mapid
    this.SubUserLayer = matdata.SubUserLayer
    this.Module = matdata.Module
  }



  PopupMode = "territory_list" //edit_territory , create_newterritory

  ngOnInit() {

    this.getTerritoryData()
    this.UserList()
  }

  DialogClose() {
    this.dialogRef.close();
  }

  getTerritoryData() {
    this.assignUserService.TerritoryList(this.mapid).subscribe(result => {
      if (result.http_code == 200 && result.data.length > 0) {
        this.territoryList = result.data
      }
      else {
        this.showErrorMessage1 = "No Territory Data Found. Please Create a New Territory."
      }
    })
  }


  UserList() {
    this.assignUserService.getSubUserList().subscribe(data => {
      console.log(data)
      if (data.data.length > 0) {
        this.SubUserList = data.data
      } else {
        this.showErrorMessage2 = "user_not_found"
      }
    })
  }

  ChangePopupMode(value) {
    this.PopupMode = value;
    this.territoryForm.reset()
    this.SelectedSubUser = false
  }



  CreateTerritory() {
    this.PopupMode = "create_newterritory"
  }



  EditTerritoryData(editData) {
    this.territoryForm.setValue(editData.territory_name)

    this.SubUserList.forEach(val => {
      if (val.id == editData.userid) {
        this.SelectedSubUser = val
      }
    })
    this.PopupMode = 'edit_territory'
  }


  SaveEditTerritoryData() {
    this.userLoader = true

    let obj = {
      "mapid": this.mapid,
      "userid_forAssign": this.SelectedSubUser.id.toString(),
      "territory_name": this.SelectedTrrData.territory_name,
      "new_territory_name":this.territoryForm.value ,
      "layerid": this.SubUserLayer.layerid
    }

    this.assignUserService.SaveEditTerritory(obj).subscribe(result=>{
      this.userLoader = false
      if(result.http_code ==200){ 

          this.getTerritoryData()
          this.PopupMode = "territory_list"
          this.SelectedSubUser = ""
          this.SubUserLayer.style_details.style_attributes = result.data.style_details.style_attributes

          this.territoryForm.reset()


      }
    })

  }


  onFinalSubmit(option) {
    console.log(this.territoryForm.valid)



    if (option == "create_newterritory") {
      if (!this.territoryForm.valid && !this.SelectedSubUser)
        return
      this.dialogRef.close({ 
        "userid_forAssign": this.SelectedSubUser.id,
         "territory_name": this.territoryForm.value,
         "SubUserLayer" :this.SubUserLayer
     })
    }
    else if (option == "form_territorylist") {
      this.dialogRef.close({ 
        "userid_forAssign": this.SelectedTrrData.userid,
        "territory_name": this.SelectedTrrData.territory_name,
        "SubUserLayer" :this.SubUserLayer
       })
    }
    else if(option=="share"){
      this.dialogRef.close({ 
        "userid_forAssign": this.SelectedSubUser.id,
        "territory_name":  this.SelectedSubUser.uname,
        "SubUserLayer" :this.SubUserLayer
       })
    }
  }

  OnSelectMultiUser(event){
    console.log(event)
    console.log(this.SelectedSubUser) 
  }


  OpenAddUserPopup(){
    const assignUserPopup = this.matDialog.open(AddNewUserModalComponent, {
      width: "70%",
    })

    assignUserPopup.afterClosed().subscribe(data=>{
      if(data){
        this.UserList() 
      }
    })

  }


  get CreateAndAssignValidation(){
    return !(this.territoryForm.valid && this.SelectedSubUser)
  }



}

export function SymbolsAndSapceValidation(control: AbstractControl) {
  if (!/^[^`~!@#$%\^&*()_+={}|[\]\\:';"<>?,./]*$/.test(control.value)) {
    return { symbols: true };
  }

  else if ((control.value as string).indexOf(' ') >= 0) {
    return { cannotContainSpace: true }
  }

  return null;
}
